import BonusCategoryServices from "../../services/BonusCategoryServices";
const state = {
    loadingBonusCategory: false,
    bonusCategoryPending: [],
    bonusCategoryPendingPdf: [],
    bonusCategoryPendingExcel: [],
    bonusCategoryLiquidation: [],
    bonusCategoryPermissionApproveAndBill: false,
    bonusCategorySelected: [],
    bonusCategoryPreliquidationPending: [],
    bonusCategoryPdf: [],
    bonusCategoryExcel: [],
    bonusCategoryLiquidationDetail: [],
    isBroker: false,
};
import { globalData } from "@/main";
const getters = {
    loadingBonusCategory: state => {
        return state.loadingBonusCategory;
    },
    bonusCategoryPending: state => {
        return state.bonusCategoryPending;
    },
    bonusCategoryPendingPdf: state => {
        return state.bonusCategoryPendingPdf;
    },
    bonusCategoryPendingExcel: state => {
        return state.bonusCategoryPendingExcel;
    },
    bonusCategoryLiquidation: state => {
        return state.bonusCategoryLiquidation;
    },
    bonusCategoryPermissionApproveAndBill: state => {
        return state.bonusCategoryPermissionApproveAndBill;
    },
    bonusCategorySelected: state => {
        return state.bonusCategorySelected;
    },
    bonusCategoryPreliquidationPending: state => {
        return state.bonusCategoryPreliquidationPending;
    },
    bonusCategoryPdf: state => {
        return state.bonusCategoryPdf;
    },
    bonusCategoryExcel: state => {
        return state.bonusCategoryExcel;
    },
    bonusCategoryLiquidationDetail: state => {
        return state.bonusCategoryLiquidationDetail;
    },
    isBrokerBonusCategory: state => {
        return state.isBroker;
    },
};
const actions = {
    updateBonusCategorySelected(context, payload) {
        state.bonusCategorySelected = payload;
    },
    getBonusCategoryLiquidationDetail(context, payload) {
        context.commit("showLoadingBonusCategoryIndicator");
        return BonusCategoryServices.bonusDetailLiquidation(payload)
            .then(res => {
                if (res.data.error == 0) {
                    state.bonusCategoryLiquidationDetail = [];
                    if (!globalData.validaSucursal) {
                        state.bonusCategoryLiquidationDetail = res.data.data
                    } else {
                        for (let i = 0; i < res.data.data.length; i++) {

                            if (res.data.data[i].vtAgency.toUpperCase() == localStorage.getItem("agencyName").toUpperCase()) {
                                state.bonusCategoryLiquidationDetail.push(res.data.data[i]);
                            }

                        }


                    }

                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }

            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    getBonusCategoryLiquidation(context, payload) {
        context.commit("showLoadingBonusCategoryIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusCategoryServices.liquidation(payload, apsId)
            .then(res => {
                if (res.data.error == 0) {
                    state.bonusCategoryLiquidation = [];
                    if (!globalData.validaSucursal) {
                        state.bonusCategoryLiquidation = res.data.data
                    } else 
                        {
                             for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].vtAgency.toUpperCase() == agencyName.toUpperCase()) {
                            state.bonusCategoryLiquidation.push(res.data.data[i]);
                        }

                    }
                   
                    }
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    getBonusCategoryPending(context, payload) {
        context.commit("showLoadingBonusCategoryIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusCategoryServices.pending(payload, apsId)
            .then(res => {
                console.log(res.data)
                state.bonusCategoryPending = [];
                if (res.data.error == 0) {
                    if (!globalData.validaSucursal) {
                        state.bonusCategoryPending = res.data.data
                    } else {
                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].sucursal.toUpperCase() == agencyName.toUpperCase()) {

                                state.bonusCategoryPending.push(res.data.data[i]);
                            }
                        }
                    }

                    console.log(state.bonusCategoryPending)
                } else {
                    if (res.data.error != 100) {
                        context.commit("updateNotificationError", res.data.msg);
                    }

                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    getBonusCategoryPendingPdf(context) {
        context.commit("showLoadingBonusCategoryIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;

        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusCategoryServices.pendingPdf(apsUserName, apsId, agency)
            .then(res => {
                state.bonusCategoryPendingPdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    getBonusCategoryPendingExcel(context) {
        context.commit("showLoadingBonusCategoryIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusCategoryServices.pendingExcel(apsUserName, apsId, agency)
            .then(res => {
                state.bonusCategoryPendingExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    getBonusCategoryPreliquidationPending(context, payload) {
        context.commit("showLoadingBonusCategoryIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusCategoryServices.preliquidation(payload, apsId, agency)
            .then(res => {
                if (res.data.error == 0) {
                    state.bonusCategoryPreliquidationPending = [];
                    if (!globalData.validaSucursal) {
                        state.bonusCategoryPreliquidationPending = res.data.data
                    } else {
                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].vtAgency.toUpperCase() == agencyName.toUpperCase()) {
                                state.bonusCategoryPreliquidationPending.push(res.data.data[i]);
                            }
                        }
                    }


                } else {
                    //Erro 100 no viene informacion
                    if (res.data.error == 100) {
                        state.bonusCategoryPreliquidationPending = [];
                    } else {
                        context.commit("updateNotificationError", res.data.msg);
                    }

                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    bonusCategoryPreliquidationValidatePermission(context) {
        const apsRuc = context.rootGetters.userProfile.identity;
        return BonusCategoryServices.validatePermission(apsRuc)
            .then((res) => {
                if (res.data.error == 0) {
                    state.bonusCategoryPermissionApproveAndBill = true;
                } else {
                    state.bonusCategoryPermissionApproveAndBill = false;
                }
            })
            .catch(() => {
                state.permissionApproveAndBill = false;
            })
    },
    sendBonusCategoryPreliquidationGeneration(context) {
        context.commit("showLoadingBonusCategoryIndicator");
        const apsRuc = context.rootGetters.userProfile.identity;
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusCategoryServices.preliquidationGeneration(null, apsRuc, apsId, agency)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    sendBonusCategoryPreliquidationApprove(context, complianceBonus) {
        let data = [complianceBonus];
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusCategoryServices.preliquidationApprove(data, apsId, agencyName)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    sendBonusCategoryPreliquidationApproveAndBill(context, complianceBonus) {
        let data = [complianceBonus];
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusCategoryServices.preliquidationApproveAndBill(data, apsId, agencyName)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    sendBonusCategoryPreliquidationReject(context, complianceBonus) {
        let data = [complianceBonus];
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusCategoryServices.preliquidationReject(data, apsId, agencyName)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    getBonusCategoryPdf(context, payload) {
        context.commit("showLoadingBonusCategoryIndicator");
        return BonusCategoryServices.bonusCategoryPdf(payload)
            .then(res => {
                state.bonusCategoryPdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    getBonusCategoryPreliminarPdf(context, payload) {
        context.commit("showLoadingBonusCategoryIndicator");
        return BonusCategoryServices.bonusCategoryPreliminarPdf(payload)
            .then(res => {
                state.bonusCategoryPdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    getBonusCategoryExcel(context, payload) {
        context.commit("showLoadingBonusCategoryIndicator");
        return BonusCategoryServices.bonusCategoryExcel(payload)
            .then(res => {
                state.bonusCategoryExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusCategoryIndicator");
            });
    },
    validateIsUserAgentBonusCategory(context, userId) {
        return BonusCategoryServices.IsUserAgent(userId)
            .then((respuesta) => {
                console.log(respuesta.data);
                context.commit("loadingAsBrokerBonusCategory", { isBroker: respuesta.data != null });
                state.isBroker = respuesta.data != null;
            })
            .catch(() => {
            })
            .finally(() => {
            });
    },
};
const mutations = {
    showLoadingBonusCategoryIndicator(state) {
        state.loadingBonusCategory = true;
    },
    hideLoadingBonusCategoryIndicator(state) {
        state.loadingBonusCategory = false;
    },
    loadingAsBrokerBonusCategory(state, { isBroker }) {
        state.isBroker = isBroker;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};